import axiosApiInstance from '@/services/api'
import { get as _get } from 'lodash'

import TokenService from '@/services/token.service'
import router from '@/router'
import { uuid } from 'vue-uuid';

const axiosInterceptorsSetup = () => {
	axiosApiInstance.interceptors.request.use(
		(config) => {
			config.headers['access-token'] = TokenService.getAccessTokenFromStorage()
			config.headers['device-id'] = TokenService.getDeviceIdFromStorage() || uuid.v4()

			return config
		},
		(error) => {
			return Promise.reject(error)
		}
	)

	axiosApiInstance.interceptors.response.use(
		(response) => {
			const token = TokenService.getAccessTokenFromBody(response)
			if (token) TokenService.saveAccessToken(token)

			const dataStatus = _get(response, 'data.status', null)
			const dataErrorMessage = _get(
				response,
				'data.errors.message',
				'API error without message'
			)
			if (dataStatus === 'SERVER_ERROR') {
				return Promise.reject(new Error(dataErrorMessage))
			}

			return response
		},
		async function (error) {
			const errorResponse = _get(error, 'response', {})
			const isUnauthorized = errorResponse.status === 401

			/* TODO: remove */
			if (
				errorResponse.status === 422 &&
				errorResponse.data.error === 'A chat with such user has already been created !'
			) {
				await router.push({ name: 'chats' })
			}

			if (isUnauthorized) {
				TokenService.clearStorageTokens()

				const { data } = errorResponse
				if (data?.expired) {
					return TokenService.refreshToken(error)
				} else {
					// $store.dispatch('auth/logout');
					// await this.$router.push("/login");
				}
			}

			return Promise.reject(error)
		}
	)
}

export default axiosInterceptorsSetup
